
export default {
  components: {},
  props: {
    noShowAppointment: {
      required: true,
      type: Object,
      default: null,
    },
  },
  computed: {
    setFairPayStatus() {
      switch (this.noShowAppointment.fairPayStatus) {
          case 0: return 'UNKNOWN'; 
          case 1: return 'NEW'
          case 2: return 'REMINDER1'
          case 3: return 'REMINDER2'
          case 4: return 'PARDONED'
          case 5: return 'PAID'
      }
    },
    formatTitle() {
      let ret = this.noShowAppointment.treatmentNames
      let max = this.$vuetify.breakpoint.mdAndDown ? 30 : 50
      return ret.length > max ? ret.substring(0, max) + '...' : ret
    }
  },
  methods: {
    getDate(appointmentDate) {
      return new Date(appointmentDate).toLocaleDateString("no-NO", {
        year: "numeric",
        month: this.$vuetify.breakpoint.smAndDown ? "numeric" : "long",
        day: "numeric",
      });
    },
    formatPrice(price) {
      return price.toFixed(2).replace(".", ",");
    },
  },
};
